module.exports = __webpack_public_path__ + "static/media/celebs1.de57c426.jpg";